import { render } from "./updateMulti.vue?vue&type=template&id=35198da5&scoped=true"
import script from "./updateMulti.vue?vue&type=script&lang=js"
export * from "./updateMulti.vue?vue&type=script&lang=js"

import "./updateMulti.vue?vue&type=style&index=0&id=35198da5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35198da5"

export default script